import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Observable } from 'rxjs';

import { UserProfile } from '../../../models/user-profile';
import { UpdateUserProfileRequestAction } from '../../../state-management/actions/login-details';
import { State as LoginDetailsState } from '../../../state-management/reducers/login-details';
import { StoreState } from '../../../state-management/store';

@Component({
  selector: 'app-optin',
  templateUrl: './optin.component.html',
})
export class OptinComponent implements OnInit {
  // Store states and Subscriptions
  public loginDetails$: Observable<LoginDetailsState>;

  // Flag to show if form has been submitted
  public submitted = false;

  // Validation error to display
  public errors: string = null;

  // FormGroup for the profile form
  public fg: UntypedFormGroup = null;

  public error: any;

  // User profile.
  @Input() userProfile: UserProfile;

  public token: any;

  constructor(
    private store: Store<StoreState>,
    private router: Router,
    private _fb: UntypedFormBuilder
  ) {
    this.loginDetails$ = this.store.select('loginDetails');
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    if (this.userProfile.optIns.length) {
      this.router.navigate(['/home']);
    }

    this.fg = this._fb.group({
      optIn: null,
    });
  }

  onSubmitForm() {
    let newUser = false;
    this.submitted = true;
    this.errors = null;

    if (window) {
      window.scrollTo(0, 0);
    }

    const optIns = [];

    const optInObject = {
      offers_by_email: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      offers_by_sms: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      offers_by_telephone: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      information_by_email: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      information_by_sms: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      information_by_telephone: this.fg.value.optIn
        ? moment.utc().format('YYYY-MM-DD HH:mm:ss')
        : null,
      add_to_find_an_installer: null,
    };

    optIns.push(optInObject);

    // Attempt to determine if this is from a simple sign on registration.
    if (this.userProfile.firstName == ' ' && this.userProfile.lastName == ' ') {
      newUser = true;
    }

    if (this.fg.valid) {
      const profile = UserProfile.fromFormData(
        this.userProfile,
        [], // this can be empty as it won't be updated
        optIns,
        true,
        true
      );

      this.store.dispatch(
        new UpdateUserProfileRequestAction({ profile: profile })
      );

      if (!newUser) {
        this.router.navigate(['/home']);
      } else {
        this.router.navigate(['/register/update']);
      }
    }
  }
}
